const EMOJI_FONT_LIST =
    "'Apple Color Emoji','Segoe UI Emoji', NotoColorEmoji,'Segoe UI Symbol','Android Emoji',EmojiSymbols";
const INTERNAL_EMOJI_FONT_NAME = 'EmojiFont';

export default function applyEmojiFont(element: HTMLElement) {
    let newFontFamily = INTERNAL_EMOJI_FONT_NAME;

    const originalFontFamily = element.style.fontFamily;
    if (originalFontFamily && originalFontFamily.toLowerCase().indexOf('emoji') < 0) {
        newFontFamily += ',' + originalFontFamily;
    }

    newFontFamily += ',' + EMOJI_FONT_LIST;

    element.style.fontFamily = newFontFamily;
}
